import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { HandlerManager                                 } from 'src/app/managers/handler/handler.manager';
import { LoadingManager                                 } from 'src/app/managers/loading/loading.manager';
import { SessionManager                                 } from 'src/app/managers/session/session.manager';
import { User                                           } from 'src/app/beans/login/user/user.bean';
import { Progress                                       } from 'src/app/beans/progress_mode/progress_mode.progress';
import { Site                                           } from 'src/app/beans/site/site.bean';
import { Radio                                          } from 'src/app/interface/radio/radio';
import { MatRadioChange                                 } from '@angular/material/radio';

@Component
({
  selector: 'progress-radio',
  templateUrl: './progress-mode.radio.html',
  styleUrls: ['./progress-mode.radio.scss']
})

export class ProgressRadio implements OnInit , Radio {

  @Input()  forceDisabled : boolean = false;
  @Input()  vertical      : boolean = false;

  @Input() autoSelectFirst: boolean = false

  title_none     : string   =   "radio.progress.label.none"
  title_single   : string   =   "radio.progress.label.single"
  title_multiple : string   =   "radio.progress.label.multiple"

  @Input() values         : Progress[]
  
  private site: Site
  @Input( 'site' ) set _site( site: Site )
  { 
    this.values = []   
    this.site = site
    if( site )
      if (this.values)  this.retriveValues(site.id)
      else              this.init         (site.id)
  }

  @Output() change: EventEmitter<Progress> = new EventEmitter<Progress>()
  currentValue: Progress

  constructor
  (
    private _handler: HandlerManager,
    private _loader : LoadingManager,
    private _session: SessionManager,
  ) { }

  ngOnInit() 
  {
    
  }

  selectFirst (): void 
  {
    if ( this.values && this.values.length > 0) {
      this.currentValue = this.values[0]      
    }
  }

  selectElement(el: any): void 
  {
    
    const find = this.searchElement(el)
    
    if (find) this.currentValue = find 
  }

  selectElementByPos(pos: number): void 
  {
    if (!this.values) return
    if (this.values.length <= pos) return

    this.currentValue = this.values[pos] 
  }

  searchElement(prog: Progress): any
  {
    if (!this.values) return undefined    
    return this.values.find ( (el) => prog.id == el.id ) 
  }

  async onChange(rbChange: MatRadioChange) 
  {
    this.setSelectedValue(rbChange.value)    
    if (this.site)
      await this.updateCallMode( this.site.id, rbChange.value.id )
  }

  isDisabled(): boolean
  {
    return      this.forceDisabled 
            ||  !this.values
            ||  this.values.length <= 1
  }

  getLength(): number
  {
    if ( !this.values ) return -1
     return this.values.length
  }

  hasLabel(){
    return this.title_none || this.title_single || this.title_multiple 
  }

  async init(siteId: number)
  {
    await this.retriveValues(siteId)      
    if  (this.autoSelectFirst ) this.selectFirst    (             )   
  }

  getSelectedValue() {
    return this.currentValue
  }

  setSelectedValue(value: Progress): void 
  {
    this.currentValue = value
    this.change.next(value)
  }

  clearSelectedValue(): void 
  {
    this.currentValue = undefined
  }

  async retriveValues(siteId: number)
  {

    const user  = this._session.user().get()

    if ( !User.isKind(user) ) return // TODO handle user incorrect 

    this._loader.start()

    let response = await this._handler.progress().get( (user as User).token, siteId)

    this._loader.stop()

    if (!response) return 

    const list = ( response as any ).list as Progress[]
    
    let selected = list.find( prog => prog.enabled == 1)

    this.values = list
    this.selectElement(selected)

    return list
  }

  async updateCallMode( siteId: number, callModeId: number )
  {
    const user  = this._session.user().get()

    if ( !User.isKind(user) ) return // TODO handle user incorrect 

    this._loader.start()

    let response = await this._handler.progress().update( (user as User).token, siteId, callModeId )

    this._loader.stop()

    if (!response) return

    //Insert well done message

  }
}
